/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

export enum MaintenanceStatus {
    Unknown = 0,
    Normal = 1,
    Pending = 2,
    Urgent = 3,
    Critical = 4,
}

/**
 * 
 * @export
 * @interface NextServiceDto
 */
export interface NextServiceDto {
    /**
     * 
     * @type {string}
     * @memberof NextServiceDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NextServiceDto
     */
    nextServiceWorkingHours?: number;
    /**
     * 
     * @type {number}
     * @memberof NextServiceDto
     */
    currentRuntimeHour?: number;
    /**
     * 
     * @type {number}
     * @memberof NextServiceDto
     */
    workingHoursTillService?: number;
    /**
     * 
     * @type {number}
     * @memberof NextServiceDto
     */
    pcntTillService?: number;
    // /**
    //  * 
    //  * @type {number}
    //  * @memberof NextServiceDto
    //  */
    // maintenanceState : MaintenanceStatus;
    /**
     * 
     * @type {number}
     * @memberof NextServiceDto
     */
    maintenanceStatus? : MaintenanceStatus;
}

export function NextServiceDtoFromJSON(json: any): NextServiceDto {
    return NextServiceDtoFromJSONTyped(json, false);
}

export function NextServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextServiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nextServiceWorkingHours': !exists(json, 'nextServiceWorkingHours') ? undefined : json['nextServiceWorkingHours'],
        'currentRuntimeHour': !exists(json, 'currentRuntimeHour') ? undefined : json['currentRuntimeHour'],
        'workingHoursTillService': !exists(json, 'workingHoursTillService') ? undefined : json['workingHoursTillService'],
        'pcntTillService': !exists(json, 'pcntTillService') ? undefined : json['pcntTillService'],
        'maintenanceStatus': !exists(json, 'maintenanceStatus') ? MaintenanceStatus.Unknown : json['maintenanceStatus'] as MaintenanceStatus,
        // 'maintenanceState': !exists(json, 'maintenanceState') ? MaintenanceStatus.Unknown : json['maintenanceState'] as MaintenanceStatus,
    };
}

export function NextServiceDtoToJSON(value?: NextServiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'nextServiceWorkingHours': value.nextServiceWorkingHours,
        'currentRuntimeHour': value.currentRuntimeHour,
        'workingHoursTillService': value.workingHoursTillService,
        'pcntTillService': value.pcntTillService,
        'maintenanceStatus': value.maintenanceStatus,
        // 'maintenanceState': value.maintenanceState,
    };
}


